import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import WaiterServices from "./WaiterServices";

const initialState = {
  waiter: null,
  waiters: [],
  isError: false,
  isSuccess: false,
  isSuccessWaiter: false,
  isLoading: false,
  message: "",
};

export const getWaiters = createAsyncThunk(
  "waiter/getWaiters",
  async (_, thunkAPI) => {
    try {
      return await WaiterServices.getWaiters();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createWaiter = createAsyncThunk(
  "waiter/createWaiter",
  async (waiterName, thunkAPI) => {
    try {
      return await WaiterServices.createWaiter(waiterName);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateWaiter = createAsyncThunk(
  "waiter/updateWaiter",
  async ({ waiterName, waiterId }, thunkAPI) => {
    try {
      return await WaiterServices.updateWaiter({ waiterName, waiterId });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteWaiter = createAsyncThunk(
  "waiter/deleteWaiter",
  async (waiterId, thunkAPI) => {
    try {
      return await WaiterServices.deleteWaiter(waiterId);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const waiterSlice = createSlice({
  name: "waiter",
  initialState,
  reducers: {
    RESET_WAITER(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isSuccessWaiter = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getWaiters.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getWaiters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.waiters = action.payload;
        console.log(action.payload);
      })

      .addCase(getWaiters.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(createWaiter.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createWaiter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessWaiter = true;
        state.waiter = action.payload.newWaiter;
        toast.success(action.payload.message);
      })

      .addCase(createWaiter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(updateWaiter.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateWaiter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessWaiter = true;
        state.waiter = action.payload.waiter;
        toast.success(action.payload.message);
      })

      .addCase(updateWaiter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(deleteWaiter.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteWaiter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        toast.success(action.payload || "Waiter delete successfully.");
      })

      .addCase(deleteWaiter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        toast.error(action.payload || "Failed to delete waiter.");
      });
  },
});

export const { RESET_WAITER } = waiterSlice.actions;
export const selectWaiters = (state) => state.waiter.waiters;
export const selectSuccessWaiter = (state) => state.waiter.isSuccessWaiter;
export default waiterSlice.reducer;
